import { Utils } from "@core/helpers/Utils";

export class DataLoadOptions
{

    //Member variables
    private Search: string
    private SearchFields: string[]
    private Sort: string
    private IsSortDescending: boolean;
    private Skip: number
    private Take: number
    private ComplexFilter: string;
    private DistinctField: string

    //Convert the loadOptions received from DevExpress controls to a structure we can recognize
    constructor(loadOptions: any)
    {
        //If empty object was passed, means we in raw mode and do not need this at all
        if (loadOptions == undefined) return;

        //Parse search 
        if (!Utils.IsEmpty(loadOptions.searchValue))
        {
            this.Search = loadOptions.searchValue;
            this.SearchFields = loadOptions.searchExpr;
        }

        //Parse complex filter
        if (!Utils.IsEmpty(loadOptions.filter) && typeof loadOptions.filter !== 'function')
        {
            this.ComplexFilter = (JSON.stringify({ Filter: loadOptions.filter }));
        }

        //Parse sort - can come as an array or simple field name
        if (!Utils.IsEmpty(loadOptions.sort) )
        {
            if (Array.isArray(loadOptions.sort))
            {
                this.Sort = loadOptions.sort[0].selector;
                this.IsSortDescending = loadOptions.sort[0].desc;
            }
            else
            {
                this.Sort = loadOptions.sort;
            }
        }

         


        //Parse search 
        if (!Utils.IsEmpty(loadOptions.dataField)) this.DistinctField = loadOptions.dataField;


        //Parse take/skip
        if (!Utils.IsEmpty(loadOptions.skip)) this.Skip = loadOptions.skip;
        if (!Utils.IsEmpty(loadOptions.take)) this.Take = loadOptions.take;

    }
     
    //Return the load options as a query string 
    public GetLoadOptions(): any
    {

        //Sort+Search
        var result: any = {};
        if (!Utils.IsEmpty(this.Search) && !Utils.IsEmpty(this.SearchFields))
        {
            result.DLOSearch = Utils.ConvertStringToBase64(this.Search);
            result.DLOSearchFields = Utils.ConvertStringToBase64(this.SearchFields.toString());
        }
        if (!Utils.IsEmpty(this.Sort))
        {
            result.DLOSort = this.Sort;
            if (this.IsSortDescending) result.DLOIsSortDescending = 1;
        }

        //Skip+Take
        if (this.Skip > 0) result.DLOSkip = this.Skip;
        if (this.Take > 0) result.DLOTake = this.Take;

        if (!Utils.IsEmpty(this.ComplexFilter)) result.DLOComplexFilter = Utils.ConvertStringToBase64(this.ComplexFilter);
        if (!Utils.IsEmpty(this.DistinctField)) result.DLODistinctField = Utils.ConvertStringToBase64(this.DistinctField);

        return result;
    }


}
